import { handleFetchApiResponse } from '../../../utils/handleFetchApiResponse';
import { TrialsResponse } from '../models/TrialsResponse';

interface ExtendTrialProps {
  bundleId?: string;
  trialId?: string;
  duration: number;
  errorMessage: string;
  accountId: number;
}

const BASE_URL = '/api/v2/adm/trials/trials';

export const extendBundleTrial = async ({
  bundleId,
  duration,
  errorMessage,
  accountId,
}: ExtendTrialProps) => {
  const response = await fetch(`${BASE_URL}/bundle/${bundleId}/extend`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      duration,
      hotjar_account_id: accountId,
    }),
  });

  return handleFetchApiResponse<TrialsResponse[]>(response, errorMessage);
};

export const extendSingleTrial = async ({
  trialId,
  duration,
  errorMessage,
  accountId,
}: ExtendTrialProps) => {
  const response = await fetch(`${BASE_URL}/${trialId}/extend`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      duration,
      hotjar_account_id: accountId,
    }),
  });

  return handleFetchApiResponse<TrialsResponse[]>(response, errorMessage);
};
